import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class VSConsensusPageDataService {
  apiEP: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getVSConsensusMeta = (ticker: string) => {
    return this.http.get(
      `${this.apiEP}/api/get_analysis_dashboard_meta/?company=${ticker}&analysis_type=vsConsensus`,
    );
  };

  getPgData = (
    period: string,
    pg: string,
    ticker: string,
    source: string,
    growthType: string,
  ) => {
    const queries = [
      `period=${period}`,
      `pg=${pg}`,
      `cut=NMV`,
      `ticker=${ticker}`,
      `source=Consensus`,
      `source=${source}`,
      `revision=Current`,
      `growthType=${growthType}`,
      `depth=implied`,
      `${growthType === "Analytics" ? "cva=Show Variation" : ""}`,
    ];
    return this.http.get(`${this.apiEP}/api/pg?${queries.join("&")}`);
  };

  //https://app.visiblealpha.com/api/get_revision_dashboard_lineitems/?version=1&pg=MON&cut=NMV&ticker=AAL
  getLineitemsData = (pg: string, cut: string, ticker: string) => {
    const queries = [`version=1`, `pg=${pg}`, `cut=${cut}`, `ticker=${ticker}`];
    return this.http.get(
      `${this.apiEP}/api/get_revision_dashboard_lineitems/?${queries.join(
        "&",
      )}`,
    );
  };

  saveUserFilters = (
    jsonData: Record<string, any>,
    company: string,
  ): Observable<any> => {
    return this.http.post(
      `${this.apiEP}/api/analysis_dashboard_history/?ticker=${company}&analysis_type=vsConsensus`,
      { company, jsonData, source: null, cut: null },
    );
  };

  clearFilter = (deleteHistoryObj: any) => {
    return this.http.post(`${this.apiEP}/api/deletegridpanelshistory/`, {
      viewdata: deleteHistoryObj.viewdata,
    });
  };
}
